import restorePasswordComponent from './restore-password.component';

const restorePasswordModule = angular.module('restorePassword', [
])
  .component('restorePassword', restorePasswordComponent)
  .name;

export default restorePasswordModule;
